import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { getEmitterTypeToEnum } from '@semios/app-platform-values-helpers-and-types'
import type {
  TValuesCurrentIrrigationZones,
  TValuesCurrentPoints,
  TValuesCurrentProperties,
} from 'App/Map/types'

export const insertEmitterTypeForStatus = (
  emitterType: TEmitterType,
): TValuesCurrentPoints | TValuesCurrentIrrigationZones | TValuesCurrentProperties =>
  `irrigationIsOn_${getEmitterTypeToEnum(emitterType)}_status`
